export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ adresu"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ konta"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waluta"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz adres"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz konto"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tworzenie nowego adresu"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz nowe konto"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź nazwę"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz walutę"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz typ"])}
}